import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "c-cu-alert-container" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "body" }
const _hoisted_4 = { class: "body__label" }

import { AlertCircle, CheckCircle } from "utruckin-icons";
import { useNotification } from "@/utils/notification";


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomAlert',
  setup(__props) {

const { notificationList, deleteNotification } = useNotification();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, { name: "toast" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notificationList), (notification, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: notification.uid,
            class: "c-cu-alert",
            style: _normalizeStyle({
          top: `${index * 12}px`,
          right: '12px',
          zIndex: 100 + index,
        }),
            onClick: ($event: any) => (_unref(deleteNotification)(notification.uid))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: _normalizeClass(["body__icon", notification.kind])
              }, [
                (notification.kind == 'success')
                  ? (_openBlock(), _createBlock(_unref(CheckCircle), {
                      key: 0,
                      size: 24
                    }))
                  : (_openBlock(), _createBlock(_unref(AlertCircle), {
                      key: 1,
                      size: 24
                    }))
              ], 2),
              _createElementVNode("div", _hoisted_4, _toDisplayString(notification.text), 1)
            ])
          ], 12, _hoisted_2))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})